module.exports = __webpack_public_path__ + "static/media/angle-down_orange.d64ae244.svg";